import { useStore, selectCreature } from '@/infra/store';
import { useT } from '@/infra/i18n';
import { getWorldService } from '@/services/world';

const FONT_PIXEL = '"Courier New", monospace';
const ASSET_ROOT = '/assets/generated/house';

export function GoToWorldButton() {
  const t = useT();
  const c = useStore(selectCreature);
  if (!c) return null;
  const isEgg = c.lifecycle.stage === 'egg';
  const isDead = c.state.dead;
  const lowVit = c.state.vitality < 10;
  const blockedReason = isDead
    ? 'world.cannotEnter.dead'
    : isEgg
      ? 'world.cannotEnter.egg'
      : lowVit
        ? 'world.cannotEnter.lowVitality'
        : null;
  const disabled = blockedReason !== null;
  const color = '#ffd6b3';

  return (
    <button
      data-testid="btn-go-world"
      title={blockedReason ? t(blockedReason) : t('world.goToWorld')}
      disabled={disabled}
      onClick={() => {
        if (disabled) return;
        getWorldService().enterWorld();
      }}
      style={{
        position: 'fixed',
        right: 12,
        bottom: 92,
        background: disabled ? 'rgba(20, 20, 32, 0.82)' : 'rgba(12, 16, 34, 0.92)',
        color: disabled ? '#555566' : color,
        border: `1px solid ${disabled ? 'rgba(120, 120, 145, 0.28)' : 'rgba(255, 226, 188, 0.62)'}`,
        borderRadius: 999,
        padding: '10px 15px',
        cursor: disabled ? 'not-allowed' : 'pointer',
        fontFamily: FONT_PIXEL,
        fontSize: 12,
        textTransform: 'uppercase',
        letterSpacing: 0.4,
        zIndex: 90,
        display: 'flex',
        alignItems: 'center',
        gap: 9,
        minWidth: 154,
        justifyContent: 'center',
        textShadow: '0 1px 0 rgba(0,0,0,0.85)',
        boxShadow: disabled ? 'none' : `0 8px 18px rgba(0,0,0,0.24), 0 0 16px ${color}22`,
        animation: !disabled ? 'glowPixel 1.6s steps(2) infinite' : 'none',
      }}
    >
      <span style={{ width: 38, height: 38, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <img
          src={`${ASSET_ROOT}/icon-world.png`}
          alt=""
          draggable={false}
          style={{ width: 38, height: 38, objectFit: 'contain', imageRendering: 'auto' }}
        />
      </span>
      <span>{t('world.goToWorld')}</span>
      <style>{`@keyframes glowPixel {0%,100%{box-shadow:0 8px 18px rgba(255,214,179,0.18)}50%{box-shadow:0 8px 24px rgba(255,214,179,0.48)}}`}</style>
    </button>
  );
}
